import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=672da4c5&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=672da4c5&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style1 from "./layout.vue?vue&type=style&index=1&id=672da4c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672da4c5",
  null
  
)

export default component.exports